import React  from 'react'
import { usePaymentSettings } from "@auth";
import { FormGroup, SwitchInput, SwitchLabel, SwitchTag } from "../components"
import { TextInput, EmailInput, FormLabel, FormError, Select, Option } from "@components";

const EditSharedMailbox = ({
  control,
  handleSubmit, 
  onSubmit, 
  errors,
  onSubChange,
  hasPermission, 
  hasModule, 
  readPaymentRequestMerchant, 
  customersModule, 
  readCustomer,
  readCardPayout,
  allPaymentsIsTrue,
  branches,
  onBranchChange
}) => {
  const { paymentSettings } = usePaymentSettings();
  const posEnabled = !!paymentSettings?.terminals?.enabled;

  const validBranches = branches?.filter((branch) => branch.id != null) ?? [];
  // Check if at least one condition is true
  const showAdditionalSwitches =
    hasPermission(readPaymentRequestMerchant) ||
    hasPermission(readCustomer);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
      <div className="p-5">
        <ul className="space-y-6">
          <li>
            <FormGroup>
              <FormLabel>Mailbox name</FormLabel>
              <TextInput
                displayName="Mailbox name"
                control={control}
                required
                name="name"
                placeholder="e.g. sales"
                errors={errors.name}
              />
              <FormError name="name" errors={errors} />
            </FormGroup>
          </li>
          <li>
            <FormGroup>
              <FormLabel>Email address</FormLabel>
              <EmailInput
                displayName="Email address"
                control={control}
                required
                name="email"
                placeholder="e.g. sales@merchant.com"
                errors={errors.email}
              />
              <FormError name="email" errors={errors} />
            </FormGroup>
          </li>
          {validBranches.length > 0 && (
            <li>
              <FormGroup>
                <FormLabel>Branch</FormLabel>
                <Select
                  name="branchId"
                  displayName="Branch"
                  control={control}
                  placeholder="All branches"
                  onChange={onBranchChange}
                >
                  <Option value="">All branches</Option>
                  {validBranches.map((branch) => (
                    <Option key={branch.id} value={branch.id}>{branch.name}</Option>
                  ))}
                </Select>
              </FormGroup>
            </li>
          )}
        </ul>
      </div>
      {showAdditionalSwitches && (
        <div className="p-6 border-t">
          <ul className="space-y-6">
            {hasPermission(readPaymentRequestMerchant) && (
              <li>
                <FormGroup>
                  <SwitchInput
                    name="AllPayments"
                    control={control}
                    onChange={(val) => onSubChange("AllPayments", val)}
                  >
                    <SwitchLabel>All payments</SwitchLabel>
                    <SwitchTag>Receive a notification when any payment is made through Ontik, regardless of channel</SwitchTag>
                  </SwitchInput>
                </FormGroup>
              </li>
            )}
            {hasModule(customersModule) && hasPermission(readCustomer) && (
              <li>
                <FormGroup>
                  <SwitchInput
                    name="CustomerPayments"
                    control={control}
                    disabled={allPaymentsIsTrue}
                  >
                    <SwitchLabel>Customer payments</SwitchLabel>
                    <SwitchTag>Receive a notification when trade customers make a payment through any Ontik channel</SwitchTag>
                  </SwitchInput>
                </FormGroup>
              </li>
            )}
            {posEnabled && hasPermission(readPaymentRequestMerchant) && (
              <li>
                <FormGroup>
                  <SwitchInput
                    name="TerminalPayments"
                    control={control}
                  >
                    <SwitchLabel>All POS payments</SwitchLabel>
                    <SwitchTag>Receive a notification for every payment taken on the POS terminals. Not included in &apos;All payments&apos;</SwitchTag>
                  </SwitchInput>
                </FormGroup>
              </li>
            )}
            {hasPermission(readCardPayout) && (
              <li>
                <FormGroup>
                  <SwitchInput
                    name="Payouts"
                    control={control}
                    onChange={(val) => onSubChange("Payouts", val)}
                  >
                    <SwitchLabel>All payouts</SwitchLabel>
                    <SwitchTag>
                      Receive a notification when a payout from Adyen is made to your bank account. 
                      {validBranches.length > 0 && (<span>&nbsp;This option can only be scoped to All Branches</span>)}
                    </SwitchTag>
                  </SwitchInput>
                </FormGroup>
              </li>
            )}
          </ul>
        </div>
      )}
    </form>
  )
}

export default EditSharedMailbox